import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#303030",
      d: "M12.923 5.325a1.377 1.377 0 0 0-1.376-1.376H5.325a1.376 1.376 0 0 0-1.376 1.376v6.222a1.377 1.377 0 0 0 1.376 1.376h6.222a1.377 1.377 0 0 0 1.376-1.376zM0 1.975C0 .886.887 0 1.974 0h7.18q.555 0 .965.296c.26.19.441.446.582.699a.538.538 0 1 1-.94.523c-.105-.188-.194-.292-.275-.35a.53.53 0 0 0-.332-.091h-7.18a.9.9 0 0 0-.897.897v7.178l.008.119a.9.9 0 0 0 .447.662.539.539 0 0 1-.534.936A1.98 1.98 0 0 1 0 9.155zm14 9.572A2.453 2.453 0 0 1 11.547 14H5.325a2.453 2.453 0 0 1-2.453-2.453V5.325a2.453 2.453 0 0 1 2.453-2.453h6.222A2.454 2.454 0 0 1 14 5.325z"
    }, null, -1)
  ]))]))
}
export default { render: render }